<script lang="ts">
  import { pop } from "svelte-spa-router";
  import Separator from "$shared/components/Separator.svelte";
  import { onMount } from "svelte";

  export let params: { id: string };

  onMount(() => {
    if (import.meta.env.DEV) console.log("Settings mounted.");
  });
</script>

<div>
  <div class="px-[24px] py-[24px] max-mobile:px-[8px] max-mobile:py-[8px]">
    <button
      on:click={() => {
        pop();
      }}
      class="-ml-[8px]"
    >
      <img
        src="./icons/arrow-left-small.svg"
        class="w-[24px] inline p-[8px] pb-[11px]"
        alt="arrow-left"
      />
    </button>
    <h2 class="text-[#181818] text-[17px] -mt-[30px] inline relative">
      Meddelande {params.id}
    </h2>
  </div>
  <Separator customClass="max-mobile:hidden" />

  <div class="w-full p-[24px] max-mobile:px-[8px]">
    <p class="text-[12px] text-[#828282] pb-[16px]">
      Brf Laboratoriet - 2023-11-15 15:13
    </p>
    <p class="text-[14px] text-[#606060]">
      Nyligen upptäckte vi en läcka i ett av innertaken i garaget. Vi vill
      försäkra dig om att vi tar detta på största allvar och har redan satt in
      tekniker för att undersöka och åtgärda problemet. Vårt mål är att
      säkerställa att ditt garage förblir i bästa skick och att eventuella
      skador åtgärdas omedelbart.<br />
      <br />
      Våra tekniker arbetar nu på plats för att identifiera och lösa problemet.
      Vi förstår vikten av din garageplats och kommer att göra allt vi kan för
      att minimera eventuella störningar. Vi kommer att hålla dig uppdaterad med
      mer information så snart vi har en fullständig bild av situationen och de
      åtgärder som vidtagits.<br />
      <br />
      Din trygghet och tillfredsställelse är vår högsta prioritet, och vi tackar
      för ditt tålamod och förståelse medan vi hanterar detta. Om du har några
      frågor eller oro, är du välkommen att kontakta vårt kundsupportteam, som
      står redo att assistera dig.<br />
      <br />
      Vänliga hälsningar,<br />
      Parkando Kundsupport
    </p>
  </div>
</div>
